var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCe7(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #21409a;\n      }\n\n      .cls-2 {\n        fill: #fff;\n        stroke: #21409a;\n        stroke-miterlimit: 10;\n        stroke-width: 4px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 22,
    cy: 22,
    r: 20
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.68,10.46h10.41c1,0,1.72,.16,2.17,.47,.45,.31,.67,.83,.67,1.55,0,.44-.26,1.02-.79,1.73-.53,.72-1.12,1.51-1.8,2.38-.67,.87-1.37,1.95-2.08,3.24-.71,1.29-1.37,2.87-1.96,4.73-.25,.82-.43,1.51-.53,2.05-.1,.54-.22,1.25-.34,2.11-.12,.87-.23,1.53-.33,1.98-.22,1.06-.53,1.8-.93,2.21-.4,.41-.94,.62-1.6,.62s-1.15-.22-1.53-.66c-.39-.44-.58-1.1-.58-1.96,0-.67,.14-1.57,.42-2.72,.28-1.15,.74-2.52,1.38-4.12,.63-1.6,1.43-3.24,2.38-4.92,.95-1.68,2.09-3.36,3.4-5.02h-8.36c-.88,0-1.53-.16-1.96-.48-.43-.32-.65-.81-.65-1.49,0-.72,.23-1.18,.69-1.39,.46-.21,1.1-.31,1.92-.31Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCe7);
export default __webpack_public_path__ + "static/media/CE7.13b265732365f93bad4514d9dee040d7.svg";
export { ForwardRef as ReactComponent };